module.exports = __webpack_public_path__ + "img/user-bg.58ac1d63.jpg";